<div class="app-alert__title bg-style color-light font-18 font-bold">
    {{ item.data.params.headerTxtId > 0
    ? subtitles.setSubtitle(item.data.params.headerTxtId)
    : subtitles.setSubtitle(1343) }}
</div>

<div class="app-alert__close-alarm color-light font-14 cursor-pointer" (click)="closePopup(key)">
    <img class="app-alert__close-alarm-img" src="/assets/img/icons/clear-button.svg" alt="Zamknij">
</div>

<div class="app-alert__message font-15 cursor-default">
    {{ subtitles.setSubtitle(item.data.txtId) + ' ' + item.data.value | format:item.data.unit }}
</div>

<div class="app-alert__buttons-box">
    <input type="button"
           [value]="item.data.params.buttonTxtId > 0
                 ? subtitles.setSubtitle(item.data.params.buttonTxtId)
                 : subtitles.setSubtitle(1196)"
           class="app-alert__button bg-ok color-light font-bold font-14 cursor-pointer"
           (click)="popup.clearPopup(key)">
</div>